import Chart from "react-apexcharts";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { useEffect, useState } from "react";
import ColorApp from "../../components/color/color.js";
import ModalManpowerByGrade from "./modal/modalMechanicByGrade.jsx";

function QtyMechanicByGrade({ data }) {
  const [chartData, setChartData] = useState([]);
  const [modalDetail, setModalDetail] = useState({ status: false, category: "" });
  function ChartConfig(datas) {
    let series = [];
    let label = [];
    datas.forEach((data) => {
      series.push(data.qty);
      label.push(data.grade);
    });
    return {
      series: [
        {
          name: "Mechanic Grade",
          data: series,
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const { seriesIndex, dataPointIndex, w } = config;
              if (seriesIndex === null || dataPointIndex === null) return;
              const categories = w?.config?.xaxis?.categories ?? w?.globals?.categoryLabels ?? []; // fallback
              const category = categories[dataPointIndex];
              const seriesName = w?.globals?.seriesNames?.[seriesIndex];
              const value = w?.globals?.series?.[seriesIndex]?.[dataPointIndex];
              setModalDetail({ status: true, category });
            },
          },
          zoom: {
            enabled: false,
          },
        },
        colors: [ColorApp().themeColor],
        stroke: {
          curve: "smooth",
          width: 1,
          colors: [ColorApp().themeColor],
        },
        tooltip: {
          fixed: {
            enabled: true,
          },
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: label,
          labels: {
            show: true,
            style: { colors: ColorApp().inverse, fontSize: "12px", fontFamily: ColorApp().themeFont, fontWeight: ColorApp().themeFontWeight, cssClass: "apexcharts-xaxis-label" },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: true,
          },
        },
        yaxis: {
          show: false,
        },
        grid: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val; // You can modify this function to customize label format
          },
          textAnchor: "middle",
          distributed: false,
          offsetX: 0,
          offsetY: -20,
          style: {
            fontSize: "14px",

            colors: [ColorApp().inverse],
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top", // Positions the label at the top of the bar
            },
          },
        },
      },
    };
  }
  useEffect(() => {
    setChartData(data);
  }, [data]);
  return (
    <>
      <Card>
        <CardBody className="m-5px bg-inverse bg-opacity-10">
          <div className="d-flex fw-bold small mb-3">
            <span className="flex-grow-1">Mechanic Grade Composition</span>
          </div>
          <div>{chartData.length > 0 ? <Chart series={ChartConfig(chartData).series} type="bar" options={ChartConfig(chartData).options} height={150} /> : <p>loading....</p>}</div>
        </CardBody>
      </Card>
      <ModalManpowerByGrade show={modalDetail.status} grade={modalDetail.category} onHide={() => setModalDetail((a) => ({ ...(a.status = false) }))} />
    </>
  );
}
export default QtyMechanicByGrade;
